export default __webpack_public_path__ + "static/media/wolf.27a417b3.png";